import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom';
import {
  Hydrate,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Router } from 'core/libs/router';

// Запрашиваем главный компонент по специальному алиасу.
import Site from 'site-index';

import BrowserBreakpoint from 'core/components/breakpoint/BrowserBreakpoint';
import Sentry from 'core/components/Sentry';
import SharedRenderContext from 'core/components/SharedRenderContext';

/**
 * Сервис воркер может быть только один.
 * Подключаем его в этой точке.
 */
import './sw';

import { REACT_QUERY_STATE, LB_SHARED_CONTEXT } from 'core/site/constants';

const container = document.querySelector('[data-placeholder="site-content"]');
const dehydratedState = window[REACT_QUERY_STATE];
const sharedRenderContext = window[LB_SHARED_CONTEXT];
const queryClient = new QueryClient({
  // REF: https://tanstack.com/query/v4/docs/framework/react/guides/important-defaults
  defaultOptions: {
    queries: {
      staleTime: 4 * 60 * 1000,
      notifyOnChangeProps: ['data', 'error', 'isLoading', 'status'],
      /**
       * TODO: 11158
       * Использование `retry` несовместимо с тем, как мы рендерим страницы ошибок.
       * Получается, что react-query делает повторные запросы уже после срабатывания
       * `.catch(err => renderError())`, и использование `retry` не имеет смысла
       */
      retry: false,
      // Без дополнительной индикации загрузки следующие две фичи будут
      // создавать неожиданные для юзера обновления контента, поэтому
      // пока отключаем их
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

const customHistory = createBrowserHistory({
  basename: sharedRenderContext?.routerContext?.basename,
});

const appStatus = sharedRenderContext?.routerContext?.appStatus;
const devToolsTogglerProps = {
  style: {
    opacity: 0.5,
  },
};

// Синхронизируем appStatus клиентской history со значением из SSR
if (appStatus) {
  customHistory.replace({
    ...history.location,
    state: { appStatus },
  });
}


function renderSite() {
  ReactDOM.hydrate(
    <QueryClientProvider client={queryClient}>
      <Hydrate state={dehydratedState}>
        <SharedRenderContext.Provider value={sharedRenderContext}>
          <Sentry>
            <BrowserBreakpoint>
              <Router history={customHistory}>
                <Site />
              </Router>
            </BrowserBreakpoint>
          </Sentry>
        </SharedRenderContext.Provider>
      </Hydrate>
      <ReactQueryDevtools toggleButtonProps={devToolsTogglerProps} />
    </QueryClientProvider>,
    container
  );
}

if (module.hot) {
  /**
   * Отслеживаем обновление модуля `site-index`.
   * Если он обновляется, то перерисовываем все приложение.
   */
  module.hot.accept('site-index', () => {
    queryClient.clear();
    renderSite();
  });
}

renderSite();
